module.exports = __webpack_public_path__ + "static/media/6.d9eb0fc2.jpg";